import React, {useEffect} from 'react';
import {makeStyles} from "@material-ui/core/styles";
import src from "../../../images/nophoto_lg.png";

const useStyles = makeStyles({
  root: {
    marginBottom: 30,
    display: "flex",
    alignItems: "baseline",
    justifyContent: "flex-start"
  },
  timeSend : {
    marginLeft: 20,
    color: "#789",
    fontSize: "16px",
    fontWeight: 500
  },
  textContent: {
    width: "max-content",
    padding: "20px 30px",
    display: "flex",
    alignItems: "center",
    color: "#000",
    borderRadius: "50px 50px 50px 0",
    backgroundColor: "#e9ecf7",
    fontSize: "16px",
    fontWeight: 500,
    lineHeight: "27px"
  },
  avatar: {
    position: "relative",
    display: "flex",
    overflow: "hidden",
    alignSelf: "flex-start",
    width: "50px",
    height: "50px",
    borderRadius: "50%",
    "& img": {
      marginRight: "20px",
      width: "100%",
      height: "100%",
      objectFit: "cover"
    }
  }
});

const MessageInbox = ({content, timeSend, personName, personAvatar}) => {
  const classes = useStyles();
  const baseURL = "/work/api/file";

  return(
    <div className={classes.root}>
      {personAvatar &&
      <div className={classes.avatar}>
        {personAvatar ?
          <img src={`${baseURL}/${personAvatar}`} alt="avatar"/>
          :
          <img src={src} alt="avatar"/>
        }
      </div>}
      <div className={classes.textContent}>
        {content}
      </div>
      {timeSend &&
      <span className={classes.timeSend}>
        {timeSend}
      </span>}
    </div>
  )
}

export default MessageInbox;
